import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackingCaseActionsActionsSaga } from '../../../../infrastructure/services/trackingCase';
import { historyActionsSaga } from '../../../../infrastructure/services/history'
import { activityActionsSaga } from '../../../../infrastructure/services/activity';
import { garmentCarActionsSaga } from '../../../../infrastructure/services/garmentCar'
import { userDenyActionsSaga } from '../../../../infrastructure/services/userDeny';
import { usersActionsSaga } from '../../../../infrastructure/services/users';

import { userDenyActions } from '../../../../application/actions/userDeny';
import { activityActions } from '../../../../application/actions/activity';
import { historyActions } from '../../../../application/actions/history';
import { garmentCarActions } from '../../../../application/actions/garmentCard';
import CreateForms from '../../organismos/forms';
import Modal from '../../molecula/modal/Modal';
import 'moment/locale/es';
import './index.css'
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Box, Grid, ButtonGroup, Button, Typography, Paper, Chip, Avatar, Divider } from '@mui/material';
import GradientCircularLoader from '../../molecula/circularLoader/circularLoader';
import TrackingTable from '../../organismos/trackingTable';
import FieldListSearch from '../../organismos/forms/fields/FieldListSearch/FieldListSearch'
import LineLive from '../../molecula/lineLive/lineLive';
import GarmentCar from '../../molecula/garmentCar/garmentCar';
import UsersDeny from '../../molecula/usersDeny/usersDeny';
import ComentsView from '../../molecula/ComentsView';
import ShowDocuments from '../../molecula/showDocuments/showdocuments';
import SendCase from '../../molecula/sendCase/sendCase';
import { carCaseActions } from '../../../../application/actions/carCase';
import Pay from '../../molecula/pay/pay';
import entity from './entity';
import CreateGarmentCar from '../../molecula/createGarmentCar/createGarmentCar';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import WebSocketComponent from '../../organismos/wss/ws';
import dayjs from 'dayjs';
import { TypeNotifications } from '../../organismos/wss/typeNotifications.enum';
import { reportActionsSaga } from '../../../../infrastructure/services/report';
import { reportActions } from '../../../../application/actions/report';
import { portableMobile } from '../../../../utils/helpers';



const TrackingCase = ({ estado, lassMessageAplication }) => {
  const dispatch = useDispatch();
  /*SHOW ALL DATA*/
  const { data: getAll, connection: connectionGetAll } = useSelector((store) => store.tk.trackingCase.getAll);
  const { data: getAllClient } = useSelector((store) => store.tk.client.getAll);
  const { workFlowStates } = useSelector((store) => store.tk.workFlow.states);
  const { actions } = useSelector((store) => store.tk.actions);
  const { workFlowActivities } = useSelector((store) => store.tk.workFlow.activities);
  const { data: dataCourt } = useSelector((store) => store.tk.globalData.court);
  const { roleId } = useSelector((store) => store.tk.sesion.user);
  const { data: location } = useSelector((store) => store.tk.globalData.location)
  const { connection: connectionCreateActivity, result: resultCreateActivity } = useSelector((store) => store.tk.activity.create);
  const { buffer: bufferReport, result: resultReport, error: errorReport, connection: connectionReport } = useSelector((store) => store.tk.report.getByIdDonwload);

  /*SHOW BY ID AND UPDATE DATA*/

  /*CREATE DATA*/
  const [openCreate, setOpencreate] = useState(false);
  const [habilityCreate, setHabilityCreate] = useState(false);
  const [createUser, setCreateUser] = useState({});

  const [openCreateActivity, setOpencreateActivity] = useState(false);
  const [nameActivity, setNameActivity] = useState('')
  const [createActivity, setCreateActivity] = useState({});
  const [habilityCreateActivity, setHabilityCreateActivity] = useState(false);

  /*EXTERNAL REFRES */
  const { result: resultCreate } = useSelector((store) => store.tk.carCase.create);
  const { result: resultUpdate } = useSelector((store) => store.tk.carCase.update);

  /*LOAD INITIAL*/
  const [INITIAL, setINITIAL] = useState(true);
  const [clienDefauld, setClientDefauld] = useState(null)

  /*SHOW ALL INITIAL*/
  const getAllItems = () => {
    if (estado === 3 && getAllClient.length > 0) {
      const clientId = clienDefauld === null ? getAllClient[0].id : clienDefauld.id;
      dispatch(trackingCaseActionsActionsSaga.getAll({ id: `${estado}/${clientId}` }));

    } else if (estado === 1) {
      !connectionGetAll && dispatch(trackingCaseActionsActionsSaga.getAll({ id: estado }));
    }
  }

  useEffect(() => {
    if (lassMessageAplication && lassMessageAplication.type === TypeNotifications.ACTIVITY_MAKE) { getAllItems() }
  }, [lassMessageAplication])

  useEffect(() => {
    setINITIAL(false)
  }, [getAll])

  useEffect(() => {
    setINITIAL(true)
    estado === 1 && getAllItems();
  }, [estado]);

  useEffect(() => {
    setINITIAL(true)
    estado === 3 && getAllItems();
  }, [estado, clienDefauld]);

  const updateDefauld = (clientName) => {
    const findClient = getAllClient.find(item => item.nameComapny === clientName)
    console.log(clientName, findClient)
    setClientDefauld(findClient)
  }


  useEffect(() => {
    getAllClient.length > 0 && updateDefauld(getAllClient[0].nameComapny);
  }, [getAllClient])


  /**FIND ENTITYS FOR CLIENT ID */
  const entityAcount = entity.COLUMS_BY_ID_ACOUNT.find(item => item.acountId === 1)
  const columns = entityAcount.columns(roleId);
  const formulario = entityAcount.forms.find(item => item.name === 'search')?.form(getAllClient, workFlowStates, workFlowActivities, dataCourt, (estado === 3 ? true : false), roleId);
  const formularioUnico = entityAcount.forms.find(item => item.name === 'searchUnique')?.form(getAllClient,(estado === 3 ? true : false), roleId);
  const [activityForm, setActivityForm] = useState([])


  /** CREATE ACTIVITY*/

  const [basicActivity] = useState({
    idCase: null,
    idUser: null,
    idUserRol: roleId,
    activityUserDate: null,
    idActivity: null,
    idEstado: null,
    coment: null,
  })
  const [newActivity, setNewActivity] = useState({ ...basicActivity });


  const hadlerSendActivity = () => {

    //console.log(createActivity)
    const activity = newActivity
    createActivity.map((F) => F.groups.map(G => G.display && G.fields.map(F => activity[F.id] = F.value)))
    console.log(activity)
    dispatch(activityActionsSaga.create(activity))
  }



  const handlerActivity = (row, newValue, indexGroup, indexFormulario) => {
    dispatch(activityActions.createReset())
    if (newValue) {
      setNameActivity(`${newValue.name} del caso N°:${row.caseNumber}`)
      setOpencreateActivity(true)
      const activity = newActivity
      activity.idActivity = newValue.id;
      activity.idEstado = newValue.idState;
      activity.idCase = row.idcase
      console.log(activity)
      setActivityForm(entityAcount.forms.find(item => item.name === 'activity')?.form(newValue.name, newValue.id, dataCourt, location.comuna));
      setNewActivity(activity)
      console.log(newValue, row)
    }
  }

  const selectActivitys = (idcase) => {
    return <FieldListSearch
      field={{ label: 'Gestiones', options: workFlowActivities.map(item => ({ name: item.name, id: item })) }}
      onChange={handlerActivity}
      indexField={idcase}
      indexGroup={1}
      indexFormulario={1}
    //customize={false}
    //sx={}
    />
  }

  const buttonActivity = <ButtonGroup disabled={connectionCreateActivity || resultCreateActivity} fullWidth variant="contained" aria-label="Basic button group">
    <Button disabled={!habilityCreateActivity} onClick={hadlerSendActivity}>Registrar</Button>
    <Button onClick={() => setOpencreateActivity(false)}>Salir</Button>
  </ButtonGroup>

  const getFieldsCreateActivity = (get) => {
    setCreateActivity(get)
  };

  /* const getEnabledFormCreateactivity = (flag) => {
    setHabilityCreateActivity(flag)
  };
 */

  const activity = <CreateForms
    fields={activityForm ? activityForm : []}
    getFields={getFieldsCreateActivity}
    getEnabledForm={setHabilityCreateActivity}
    sxfields={{ mt: 1 }}
  />

  useEffect(() => {
    if (resultCreateActivity) {
      setOpencreateActivity(false)
    }
  }, [resultCreateActivity])


  /** CREATE ACTIONS*/
  const [openCreateActions, setOpenCreateActions] = useState(false);
  const [nameActions, setNameActions] = useState('');
  const [idAction, setIdAction] = useState(null);
  const [caseIdAction, setCaseIdAction] = useState(null);
  const [loaderactions, setLoaderAction] = useState(false);
  const [openMesssage, setMesssage] = useState(false);
  const [openDocuments, setDocuments] = useState(false);
  const [openCreateCars, setCreateCars] = useState(false);
  const { data: dataHistory, connection: connectionHistory } = useSelector((store) => store.tk.history.getById);
  const { data: dataGarmentCar, connection: connectionGarmentCar } = useSelector((store) => store.tk.garmentCar.getById);
  const { data: dataUserDenyById, connection: connectionUserDenyById } = useSelector((store) => store.tk.userDeny.getById);
  const { data: dataUserGetAll, connection: connectionUserGetAll } = useSelector((store) => store.tk.users.getAll);
  const { data: rolesUsers } = useSelector((store) => store.tk.role);
  const { connection: connectionUpdatecase, result: resultUpdatecase } = useSelector((store) => store.tk.carCase.updateStatus);
  const { connection: connectionPayCreate } = useSelector((store) => store.tk.pay.create);
  const { connection: connectionPayGetById } = useSelector((store) => store.tk.pay.getById);



  let actionCallBack = (dataReturn) => {
    console.log(dataReturn)
    if (idAction === 3) {
      const data = { caseId: dataUserDenyById.caseId, usersId: dataReturn }
      dispatch(userDenyActionsSaga.create({ data }));
    }
  };



  const handlerAction = (row, item, indexGroup, indexFormulario) => {
    console.log(row, item, indexGroup, indexFormulario)

    if (item) {
      setIdAction(item.id)
      if (item.id === 1) {
        dispatch(historyActions.getByIdReset())
        setNameActions(`Registro de actividades asocida a juicio N: ${row.caseNumber}`)
        dispatch(historyActionsSaga.getById({ id: row.idcase }))
        setOpenCreateActions(true)

      } else if (item.id === 3) {
        dispatch(userDenyActions.GetByIdReset())
        dispatch(userDenyActions.createReset())
        setNameActions(`Gestionar Equipo de trabajao asociado al juicio N: ${row.caseNumber}`)
        dispatch(userDenyActionsSaga.getById({ id: row.idcase }))
        dispatch(usersActionsSaga.getAllUsers())
        setOpenCreateActions(true);

      } else if (item.id === 4) {
        setCaseIdAction(row.idcase)
        setNameActions(`Mensaje de juicio N: ${row.caseNumber}`)
        setMesssage(true)

      } else if (item.id === 6) {
        dispatch(garmentCarActions.getByIdReset())
        setNameActions(`Prenda vinculada al juicio N: ${row.caseNumber}`)
        dispatch(garmentCarActionsSaga.getById({ id: row.idcase }))
        setOpenCreateActions(true)

      } else if (item.id === 7) {
        setCaseIdAction(row)
        setNameActions(`Demanda del juicio N:  ${row.caseNumber}`)
        setDocuments(true)

      } else if (item.id === 8) {
        setCaseIdAction(row)
        setNameActions(`Editando datos de la demanda N: ${row.caseNumber}`)
        setCreateCars(true)

      } else if (item.id === 9) {
        setCaseIdAction(row)
        setNameActions(`Abonos de la demanda N:  ${row.caseNumber}`)
        setOpenCreateActions(true)

      } else if (item.id === 10) {
        setCaseIdAction(row)
        setNameActions(`Enviar demanda N:  ${row.caseNumber}`)
        setOpenCreateActions(true)

      }
    }
  }

  const findComponet = () => {
    if (idAction === 1) {
      return <LineLive data={dataHistory} />
    } else if (idAction === 3) {
      return <UsersDeny users={dataUserGetAll} usersDeny={dataUserDenyById.usersId ? dataUserDenyById.usersId : []} rolesUsers={rolesUsers} action={actionCallBack} />
    } else if (idAction === 6) {
      return <GarmentCar data={dataGarmentCar} />
    } else if (idAction === 9) {
      return <Pay data={caseIdAction} state={estado} />
    } else if (idAction === 10) {
      return <SendCase data={caseIdAction} state={estado} />
    }
  }

  const findSizeComponet = () => {
    if (idAction === 1 || idAction === 7 || idAction === 9 || idAction === 10) {
      return 'md'
    } else if (idAction === 6 || idAction === 3) {
      return 'sm'
    }
  }

  useEffect(() => {
    setLoaderAction([
      connectionHistory,
      connectionGarmentCar,
      connectionUserDenyById,
      connectionUserGetAll,
      connectionUpdatecase,
      connectionPayCreate,
      connectionPayGetById
    ].some(flagt => flagt))
  }, [
    connectionHistory,
    connectionGarmentCar,
    connectionUserDenyById,
    connectionUserGetAll,
    connectionUpdatecase,
    connectionPayCreate,
    connectionPayGetById
  ])

  useEffect(() => {
    if (resultUpdatecase) {
      getAllItems();
      setOpenCreateActions(false)
      dispatch(carCaseActions.updateStatusReset())
    }
  }, [resultUpdatecase])



  const selectActions = (idcase) => {

    return <FieldListSearch
      field={{ label: 'Acciones', options: actions.map(item => ({ name: item.name, id: item })) }}
      onChange={handlerAction}
      indexField={idcase}
      indexGroup={1}
      indexFormulario={1}
    //customize={false}
    //sx={}
    />
  }

  const buttonCase = <ButtonGroup disabled={connectionCreateActivity || resultCreateActivity || connectionUpdatecase} fullWidth variant="contained" aria-label="Basic button group">
    <Button onClick={() => setOpenCreateActions(false)}>Salir</Button>
  </ButtonGroup>



  /**CREATE CASE */
  const handleShowModalCreate = (e) => {
    setCaseIdAction(null)
    setCreateCars(!openCreateCars)
  }




  /*SEARCH*/
  const [getAllFielter, setGetAllFielter] = useState([])
  const [existFilter, setExistFilter] = useState(false)

  const getFieldsCreate = (get) => {

    if (get[0]) {
      const itemsImputs = get[0].groups[0].fields;
      const itemFiletr = itemsImputs.filter(item => item.value)
      console.log(itemFiletr)
      if (itemFiletr.length > 0 && clienDefauld !== null && itemFiletr[0].id === "nameCliente" && estado === 3 && itemFiletr[0].id !== clienDefauld.nameComapny) { updateDefauld(itemFiletr[0].value) }
      if (itemFiletr.length > 0 && itemFiletr[0].id === "nameCliente" && estado === 3) { itemFiletr.shift() }
      if (itemFiletr.length > 0) {
        setExistFilter(true)
      } else {
        setExistFilter(false)
      }

      const getAllWithFileter = getAll.filter(row =>
        itemFiletr.map(itemfiletr => {
          const date1 = dayjs(row['activityLastDate'], 'DD/MM/YYYY')
          if (itemfiletr.id === 'from') {
            const date2 = dayjs(dayjs(itemfiletr.value).format('DD/MM/YYYY'), 'DD/MM/YYYY')
            return itemfiletr.value != null && (dayjs(date1).isAfter(date2) || dayjs(date1).isSame(date2))
          } else if (itemfiletr.id === 'to') {
            const date2 = dayjs(dayjs(itemfiletr.value).format('DD/MM/YYYY'), 'DD/MM/YYYY')
            return itemfiletr.value != null && (dayjs(date1).isBefore(date2) || dayjs(date1).isSame(date2))
          } else {
            return row[itemfiletr.id] != null && row[itemfiletr.id].toUpperCase().includes(itemfiletr.kind === 'date' ? dayjs(itemfiletr.value).format('DD/MM/YYYY') : itemfiletr.value.toUpperCase())
          }
        }).every(elemento => elemento === true)
        && row);

      setGetAllFielter(getAllWithFileter)
    } else {
      setGetAllFielter([])
    }
    setCreateUser(get)
  };

  const getFieldsCreateUnique = (get) => {

    if (get[0]) {
      const itemsImputs = get[0].groups[0].fields;
      const itemFiletr = itemsImputs.filter(item => item.value)
      if (itemFiletr.length > 0) {
        setExistFilter(true)
      } else {
        setExistFilter(false)
      }

      const getAllWithFileter = getAll.filter(objeto => {
        for (const propiedad in objeto) {
          if (objeto[propiedad].toString().toUpperCase().includes(itemFiletr[0]?.value.toUpperCase())) {
            return true;
          }
        }
        return false;
      });
      setGetAllFielter(getAllWithFileter)
    } else {
      setGetAllFielter([])
    }
  };

  const getEnabledFormCreate = (flag) => {
    setHabilityCreate(flag)
  };

  const search = <CreateForms
    fields={formulario ? formulario : []}
    getFields={getFieldsCreate}
    //getEnabledForm={false}
    sxfields={{ mt: 1 }}
  />

  const searchUnique = <CreateForms
    fields={formularioUnico ?  formularioUnico:[]}
    getFields={getFieldsCreateUnique}
    //getEnabledForm={false}
    sxfields={{ mt: 1 }}
  />


  /*REPORTS */
  const [idReport, setIdReport] = useState(null)

  const rerporExport = (type) => {
    setIdReport(type)
    type === 1 && dispatch(reportActionsSaga.reportDonwload({ resource: entity.TYPE_REPORT.CONSOLIDATED.resource, estado: estado }))
    type === 2 && dispatch(reportActionsSaga.reportDonwload({ resource: entity.TYPE_REPORT.SIMPLIFIED.resource, estado: estado }))
    type === 3 && dispatch(reportActionsSaga.reportDonwload({ resource: entity.TYPE_REPORT.CONFECCTIONATED.resource, estado: estado }))
  }

  const nameReport = () => {

    let nameReportfile = "";
    const finatName = `${estado === 1 ? 'activos' : 'guardados'}(${dayjs(new Date()).format('DD-MM-YYYY')}).xlsx`

    switch (idReport) {
      case 1:
        nameReportfile = `${entity.TYPE_REPORT.CONSOLIDATED.nameFile}${finatName}`;
        break;
      case 2:
        nameReportfile = `${entity.TYPE_REPORT.SIMPLIFIED.nameFile}${finatName}`;
        break;
      case 3:
        nameReportfile = `${entity.TYPE_REPORT.CONFECCTIONATED.nameFile}${finatName}`;
        break;
      default:
        break;
    }

    return nameReportfile
  }

  const handlerDownload = () => {

    const blob = new Blob([bufferReport]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nameReport());
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
    dispatch(reportActions.reportDonwloadReset())
  }

  useEffect(() => {
    bufferReport !== "" && handlerDownload()
  }, [bufferReport])

  return (
    <>
      {INITIAL && <Box sx={{ backgroundColor: '#ffffff99', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, zIndex: 100, textAlign: 'center', paddingTop: '20%' }}><GradientCircularLoader /></Box>}
      {roleId !== 10 && (
        <Fab onClick={(e) => handleShowModalCreate(e)} sx={{position:'absolute', bottom:{ xs:'auto', sm:30 }, right:{ xs:15, sm:30 }, top:{ xs:60, sm:'auto' }, zIndex:1000, scale:{ xs:0.7, sm:1 }  }} color="primary" aria-label="add">
          <MedicalServicesIcon />
        </Fab>

      )}
      <Box className='dasboard'>
        <Grid container spacing={0} sx={{ mt: 0, paddingTop: { xs: 0, sm: 1.6 }, overflow:'hidden' }}>
          <Grid sx={{/*  display: { xs: 'none', sm: 'block' }, */ backgroundColor: '#FFF', overflowY: 'auto', height: 'auto', paddingTop:2}} item xs={12} sm={3} md={2}>
            <Box>
              <Chip sx={{  display: { xs: 'none', sm: 'inline-flex' }, ml: 2, mb: 2 }} icon={<TravelExploreIcon />} label="Buscar..." />
            </Box>
            <Box sx={{display: { xs: 'none', sm: 'block' }}}>
              {
                getAllClient.length > 0 &&
                workFlowStates.length > 0 &&
                (roleId !== 10 ? workFlowActivities.length: 1) > 0 &&
                dataCourt.length > 0 &&
                search
              }
            </Box>
            <Box sx={{ overflow:'hidden', backgroundColor:'#afafc9', boxShadow: 'inset 1px -18px 20px 0px rgb(143 143 143 / 50%);', marginBottom:-1.5, paddingTop:1, marginTop:-1,display: { xs: 'block', sm: 'none' }}}>
              {
                getAllClient.length > 0 &&
                workFlowStates.length > 0 &&
                (roleId !== 10 ? workFlowActivities.length: 1) > 0 &&
                dataCourt.length > 0 &&
                searchUnique
              }
            </Box>


          </Grid>
          <Grid item sx={{ overflowY: 'hidden', paddingRight: { xs: 0, sm: 2 }, backgroundColor: '#e4e4e4ed', padding:{ xs: 0, sm: 2 } }} xs={12} sm={9} md={10}>
            {!INITIAL && <TrackingTable
              rows={existFilter ? getAllFielter : getAll}
              columns={columns}
              opctionsRows={[{ columId: 'selectActivitys', component: selectActivitys }, { columId: 'selectActions', component: selectActions }]}
              idSelected={caseIdAction}
              loaderData={connectionGetAll}
            />
            }
            {!INITIAL && roleId === 1 && (
              <Box sx={{ pt: 2, display: { xs: 'none', sm: 'flex' } }}>
                <ButtonGroup sx={{ display: { xs: 'none', sm: 'flex' } }} disabled={connectionReport} fullWidth variant="contained" aria-label="Basic button group">
                  <Button onClick={() => rerporExport(1)}>EXPORTAR CONSOLIDADO</Button>
                  <Button onClick={() => rerporExport(2)}>EXPORTAR REPORTE SIMPLIFICADO</Button>
                  <Button onClick={() => rerporExport(3)}>CONFECCION DE DEMANDA</Button>
                </ButtonGroup>
              </Box>
            )}

          </Grid>
        </Grid>
      </Box>

      <Modal
        open={openCreateActivity}
        handleClose={setOpencreateActivity}
        dataShow={activity}
        title={nameActivity}
        actions={buttonActivity}
        loader={connectionCreateActivity}
        size={'sm'}
      />

      <Modal
        open={openCreateActions}
        handleClose={setOpenCreateActions}
        dataShow={findComponet()}
        title={nameActions}
        actions={buttonCase}
        loader={loaderactions}
        size={findSizeComponet()}
      />

      {openMesssage && <ComentsView
        handlerShow={setMesssage}
        show={openMesssage}
        cardSelected={{ id: caseIdAction, title: nameActions }}
        lassMessageAplication={lassMessageAplication}
      />}

      {openDocuments && <ShowDocuments
        handlerShow={setDocuments}
        show={openDocuments}
        trackingCase={caseIdAction}
        title={nameActions}
      />}


      {openCreateCars && <CreateGarmentCar
        handlerShow={setCreateCars}
        handlerCallBack={getAllItems}
        data={caseIdAction}
        show={openCreateCars}
        title={nameActions}
      />}

    </>
  );
};

export default TrackingCase;